import React from "react";
import "./HowItWorks.css";
import Demovideo from '../../Images/DemoVideo.mp4';
import { Helmet } from "react-helmet";

const HowItWorks = () => {
  const steps = [
    { id: 1, emoji: "📚", title: "Select Your Class", desc: "Choose the class that suits your child's learning needs." },
    { id: 2, emoji: "🔍", title: "Explore Details", desc: "Read through the detailed course description and FAQs for clarity." },
    { id: 3, emoji: "🛒", title: "Proceed to Enroll", desc: 'Click on "Buy Now" to secure your spot.' },
    { id: 6, emoji: "📱", title: "Join the Community", desc: "Get added to a WhatsApp group for updates and support." },
    { id: 5, emoji: "✅", title: "Quick Confirmation", desc: "Our team will connect with you within 1 hour." },
    { id: 4, emoji: "💳", title: "Make Payment", desc: "Complete the payment using your preferred method." },
    { id: 7, emoji: "🚀", title: "Begin the Journey", desc: "Dive into an engaging and enriching learning experience!" },
  ];

  return (
    <div className="kaise-kaam-karta">
      <Helmet>
        <meta charSet="utf-8" />
        <title>How It Works - Otter Tutor</title>
        <link rel="canonical" href="http://ottertutors.com" />
      </Helmet>
      <h1>How It Works</h1>
      <div className="griding">
        {/* Row 1 */}
        <div className="row">
          {steps.slice(0, 3).map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="step">
                <div className="emoji">{step.emoji}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
              {index < 2 && <div className="dotted-line-horizontal"></div>}
            </React.Fragment>
          ))}
        </div>

        {/* Row 2 */}
        <div className="row reverse-row">
          {steps.slice(3, 6).reverse().map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="step">
                <div className="emoji">{step.emoji}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
              {index < 2 && <div className="dotted-line-horizontal"></div>}
            </React.Fragment>
          ))}
        </div>

        {/* Row 3 */}
        <div className="row single-item">
          <div className="step">
            <div className="emoji">{steps[6].emoji}</div>
            <h3>{steps[6].title}</h3>
            <p>{steps[6].desc}</p>
          </div>
        </div>

        {/* Vertical Lines */}
        <div className="vertical-line line-1"></div>
        <div className="vertical-line line-2"></div>
      </div>
        {/* Video Section */}
      <div className="video-dabba">
        <video autoPlay loop muted>
          <source src={Demovideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default HowItWorks;
